import get from 'lodash/get';
import {
  getDocumentFields,
  getFileUrl,
  getOptimizedContentfulImage,
} from 'utils/helper';
import { useState } from 'react';
import { SECTION_WITH_BACKGROUND_TITLE, isAnimated } from './helpers';

export const useCaseStudiesIntro = ({
  type,
  introSection,
  data,
}) => {
  const [isMediaViewerOpen, setIsMediaViewerOpen] = useState(false);

  const {
    title,
    subtitle,
    description,
    images,
    text: introText,
    imagesBundles,
    contentModules,
    contentList: tagsList,
  } = getDocumentFields(
    get(data, 'contentModules[0]', {}),
    [
      'title',
      'subtitle',
      'description',
      'images',
      'text',
      'imagesBundles',
      'contentModules',
      'contentList',
    ],
  );

  const {
    imageAsMediaViewerPreview, mediaViewerAsset, mediaViewerAssetSimplified, mediaViewerAssetIndex,
  } = (() => {
    const imageAsMediaViewerPreviewTag = tagsList?.find((tag) => tag.includes('image-as-media-viewer-preview'));

    if (!imageAsMediaViewerPreviewTag) {
      return {};
    }

    const [, tagPayloadString] = imageAsMediaViewerPreviewTag.split('=') ?? [];

    if (!tagPayloadString) {
      return {};
    }

    const tagPayload = JSON.parse(tagPayloadString);

    const mediaIndex = tagPayload?.mediaIndex ?? -1;
    const media = images?.[mediaIndex];
    const mediaSimplified = {
      src: get(media, 'fields.file.url'),
      type: (() => {
        const mediaType = get(media, 'fields.file.contentType');

        if (mediaType?.includes('video')) {
          return 'video';
        }

        return 'image';
      })(),
    };

    return {
      imageAsMediaViewerPreview: !!imageAsMediaViewerPreviewTag,
      mediaViewerAsset: media,
      mediaViewerAssetSimplified: mediaSimplified,
      mediaViewerAssetIndex: mediaIndex,
    };
  })();

  const contentList = contentModules?.map((module) => getDocumentFields(module, ['title', 'text']));

  const { contentModules: experiencesRaw } = getDocumentFields(
    get(data, 'contentModules[1]', {}),
    ['contentModules'],
  );

  const experiences = experiencesRaw?.map((experience) => ({
    ...experience,
    image: get(getDocumentFields(experience, ['images']), 'images')?.[0],
  }));

  const appLogoUrl = mediaViewerAssetIndex !== 1 ? getOptimizedContentfulImage(
    getFileUrl(get(images, '[1]', '')),
    { fm: 'png', fl: 'png8' },
  ) : undefined;

  const backgroundImageUrl = getOptimizedContentfulImage(
    getFileUrl(get(data, 'images[0]', '')),
    { fm: 'png' },
  );
  const backgroundImageStyle = backgroundImageUrl ? { backgroundImage: `url(${backgroundImageUrl})` } : {};

  const imageBackgroundTitle = SECTION_WITH_BACKGROUND_TITLE?.[type] || null;

  const isAnimatedImg = isAnimated(type);

  const handleMediaViewerToggle = () => {
    if (!imageAsMediaViewerPreview) {
      return;
    }

    setIsMediaViewerOpen((prev) => !prev);
  };

  return {
    type,
    backgroundImageStyle,
    introSection,
    experiences,
    appLogoUrl,
    appBackgroundImage: !!images?.[0] && images[0],
    title,
    subtitle,
    description,
    introText,
    imagesBundles,
    imageBackgroundTitle,
    contentList,
    isAnimatedImg,
    imageAsMediaViewerPreview,
    isMediaViewerOpen,
    mediaViewerAsset,
    mediaViewerAssetSimplified,
    handleMediaViewerToggle,
  };
};
